import { Field, Select } from "@/components/FormField";

const YES_NO = ["Yes", "No"];
const AMC_OPTIONS = ["Not sure", "Yes", "No"];

// Shared by Commercial Landscaping / Corporate Garden / Institutional Plantation Visit —
// mirrors the reference mockup's own regex-grouped switch case, which treats all three as one.
export default function CommercialFields({ extra, updExtra }) {
  return (
    <>
      <div className="text-sm font-semibold text-[var(--yp-primary)] sm:col-span-2 -mb-2">Organisation / Project Information</div>
      <Field id="sr-commercial-designation" label="Contact designation" value={extra.designation || ""} onChange={(v) => updExtra("designation", v)} />
      <Field id="sr-commercial-locations" label="Number of locations" type="number" value={extra.locations ?? "1"} onChange={(v) => updExtra("locations", v)} />
      <Select id="sr-commercial-boq" label="BOQ / tender available?" value={extra.boq || ""} onChange={(v) => updExtra("boq", v)} options={YES_NO} />
      <Select id="sr-commercial-amc" label="Maintenance / AMC required?" value={extra.amc || ""} onChange={(v) => updExtra("amc", v)} options={AMC_OPTIONS} />
    </>
  );
}
